export default "__VITE_ASSET__Dc8iK3kT__"